import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { SaleRepositoryImpl } from "../../domain/saleRepositoryImpl/SaleRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";
import { DEFAULT_CURRENCY } from "../shared/config";

const saleRepo = SaleRepositoryImpl.getInstance();

const useGetSales = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data } = useQuery(
    {
      queryKey: ["sales", auth],
      queryFn: async () => {
        return await saleRepo.get(auth, apiUrl);
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return { categories: data?.categories || [], currency: data ? data.currency : DEFAULT_CURRENCY, isLoading };
};

export { useGetSales };
